import BasicLight from "../../BasicSemaphore/BasicLight"
import { CircularLightCounter } from "../CircularLightCounter"
import CircularPanel from "../CircularPanel"

const CircularSemaphore = {
    Panel: CircularPanel,
    CounterLight: CircularLightCounter,
    Light: BasicLight,
}

export default CircularSemaphore
